import React from "react";
import { translate, languages } from "../base/Translation";
import { Row, Col, FormGroup, Button, Panel } from "react-bootstrap";
import FormField from "../base/FormField";

export default class TranslationForm extends React.Component {

    render() {
        
        return (
            <div>
                <Row>
                    <Col lg={12}>
                        <Panel header={translate("Základné")}>
                            <FormField
                                type="text"
                                name="original"
                                title={translate("Originál")}
                                value={this.props.data.original}
                                onChange={this.props.onChange} />
                            <FormField
                                type="text"
                                name="translated"
                                title={translate("Preklad")}
                                value={this.props.data.translated}
                                onChange={this.props.onChange} />
                            <FormField
                                type="select"
                                title={translate("Jazyk")}
                                name="language"
                                value={this.props.data.language}
                                onChange={this.props.onChange}
                                options={languages} />
                        </Panel>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <FormGroup>
                            <Button bsStyle="success" onClick={this.props.onSave}>{translate("Uložiť")}</Button>
                        </FormGroup>
                    </Col>
                </Row>
            </div >
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/translation/TranslationForm.jsx